import Deletable from './Deletable';
import Expandable from './Expandable';
import Favorite from './Favorite';

export default { Deletable: Deletable, Expandable: Expandable, Favorite: Favorite };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-virtualized-tree/es/renderers/index.js
// module id = 1000
// module chunks = 1